import { brandsAdapterSelectors } from '../redux/slices/brands';
import { createSelector } from 'reselect';
import { defaultResourceSelector } from './defaultSelectorUtils';

const getCurrentWorkspaceBrandsFromStore = (state) =>
  state.currentWorkspace.brands;

export const currentWorkspaceBrands = createSelector(
  getCurrentWorkspaceBrandsFromStore,
  (state) => (id) => brandsAdapterSelectors.selectById(state, id),
  (brandIds, getBrandById) =>
    brandIds.map((brandId) =>
      defaultResourceSelector({
        main: {
          resourceId: brandId,
          getResourceById: getBrandById,
        },
      })
    )
);
